import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';

import { PlaceOrderComponent } from '@schoolbelle/shared/components';
import { startWith, switchMap } from 'rxjs/operators';
import { GroupService } from '@schoolbelle/api/group';
import { LedgerService } from '@schoolbelle/api/ledger';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { UserToGroupService } from '@schoolbelle/api/user-to-group';
import { LoadingService } from '@schoolbelle/common/loading';
import { DialogService } from '@schoolbelle/common/dialog';
import { throwError } from 'rxjs';
import { TranslationService } from '@schoolbelle/common/translation';
import { sprintf } from 'sprintf-js';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'place-order-school',
  templateUrl: './school.component.html',
  styleUrls: ['./school.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class PlaceOrderSchoolComponent extends PlaceOrderComponent implements OnInit {
  @Output() onUpdated = new EventEmitter();
  showOptionalProducts = false;
  constructor (
    group:GroupService,
    ledger:LedgerService,
    purchase:PurchaseService,
    utg:UserToGroupService,
    cdRef:ChangeDetectorRef,
    @Inject(LOCALE_ID) locale_id:string,


    protected translation:TranslationService,
    protected loading:LoadingService, 
    protected dialogs:DialogService,
    

  ) {
    super(group, ledger, purchase, utg, cdRef, locale_id);
  }
  ngOnInit () {
    super.ngOnInit();
    this.subscriptions.add(
      this.form.valueChanges
      .pipe(
        startWith(this.form.value)
      )
      .subscribe((model:any)=>{
        this.onUpdated.next({invalid:this.form.invalid, data:this.buildParams(model)});
      })
    )    
  }

  fillInBasicValues () {
    super.fillInBasicValues();

    if (this.ledger.summary && this.ledger.summary.school_expires_at) {
      const date = new Date(this.ledger.summary.school_expires_at);
      // next day
      date.setDate(date.getDate() + 1);
      // very first tick of the next day
      date.setHours(0, 0, 0, 0);
      this.startsAt.setValue(date.getTime());

    } 


    if (this.group.currentGroup) this.groupName.setValue(this.group.currentGroup.name); 
    if (this.group.currentAddressData) this.groupAddress.setValue(this.group.currentAddressData);
    if (this.group.currentExtraInfo && this.group.currentExtraInfo.accountant_email) this.accountantEmail.setValue(this.group.currentExtraInfo.accountant_email);

  }
  order () {
    const ob = this.dialogs.confirm(sprintf(this.translation.get('place-order-confirm'), this.personInChargeEmail.value)).pipe(
      switchMap(bool=>{
        if (!bool) return throwError(this.translation.get('place-order-canceled'));
        else return super.order();
      })
    )  
    const subscription = ob.subscribe(()=>{
      if (this.group.currentGroup) {
        alert(this.translation.get('place-order-ordered'));
      } else {
        alert(sprintf(this.translation.get('place-order-ordered-with-confirm-email'), this.personInChargeEmail.value));
      }
    }, (e:HttpErrorResponse)=>{
      switch(e.status) {
        case 429 :
          alert(this.translation.get('place-order-429-error'));
        break;
        default :  
          alert(this.translation.get('place-order-unknown-error'));
      }
    });    
    this.loading.open({message:this.translation.get('place-order-ordering'), busy:subscription});
    return ob;
  }

}